import { BoardParametersV2 } from '../../model/board-parameters';
import { POPULATION_VARIABLE_NAME } from '../../app.constants';
import { ClientParameter } from '../../model/client-model/client-parameter';
import { NormalisedParameterValuePipe } from '../../feature/editor-city-inventory/pipes/normalised-parameter-value.pipe';

const normalisedParameterValuePipe = new NormalisedParameterValuePipe();

//This function will deliver values according to the Metric system
export function setUnsetParameters(parameters: ClientParameter[]): BoardParametersV2 {
  const allParameters: BoardParametersV2 = {};
  const population = parameters.find((p) => p.name === POPULATION_VARIABLE_NAME)?.value;

  parameters.forEach((p) => {
    if (p.metricValue === undefined) {
      const metricEstimate = normalisedParameterValuePipe.transform(p, population);
      allParameters[p.name] = { value: metricEstimate, usingEstimate: true };
    } else {
      allParameters[p.name] = { value: p.metricValue, usingEstimate: false };
    }
  });

  return allParameters;
}
